import { NOT_FOUND, UNPROCESSABLE_ENTITY } from '@mm/constants/status-codes';
import { getErrorJson } from '@mm/utils';
import { Dispatch } from 'redux';
import { unbusyAll } from '../actions/commonActions';
import klaviyoCRUDActions from '../actions/KlaviyoCRUDActions';
import modalActions from '../modules/modalsState/actions';
import { StoreState } from '../store-interfaces';
import commonHandler, { ResponseOrError } from './common-handler';

export const klaviyoErrorHandler =
  (dispatch: Dispatch<StoreState>) =>
  async (error: ResponseOrError, action: string) => {
    if (
      error instanceof Response &&
      error.status === NOT_FOUND &&
      action === klaviyoCRUDActions.revokeAction
    ) {
      dispatch(
        modalActions.openPrettyErrorModal({
          title: 'Could not find OAuth token',
          errorMessage: 'Please reload the page',
        }),
      );
      dispatch(klaviyoCRUDActions.unbusy());
    } else if (
      error instanceof Response &&
      error.status === UNPROCESSABLE_ENTITY
    ) {
      const parsed = await getErrorJson(error);
      dispatch(
        modalActions.openPrettyErrorModal({
          errorMessage: parsed.message,
          title: 'Failed',
        }),
      );
      dispatch(unbusyAll());
    } else {
      await commonHandler(dispatch)(error);
    }
  };
